import { QuotePlanSchema } from '../../../server/map-quotes';
import { QuoteFilters } from '../../filter-schema/useQuoteFilterSchema';
import { filterInOtherArray } from './filterInOtherArray';
import { filterWithKeyBenefitId } from './filterWithKeyBenefitId';
import { filterWithQuoteKey } from './filterWithQuoteKey';

export const applyQuoteFilter = (filterFormValues: QuoteFilters, originalQuotes: QuotePlanSchema[]) => {
	const filterWith = filterFormValues;
	const {
		insurerCompanyId,
		keyBenefitId,
		networkId,
		opConsultationCoPaymentId,
		diagnosticCoPaymentId,
		pharmacyCoPaymentId,
	} = filterWith;

	let filteredQuotes = originalQuotes;

	if (insurerCompanyId) filteredQuotes = filterWithQuoteKey(filteredQuotes, 'insuranceCompanyId', insurerCompanyId);

	if (keyBenefitId?.length) {
		filteredQuotes = filterWithKeyBenefitId(filteredQuotes, keyBenefitId);
	}

	if (networkId?.length) {
		filteredQuotes = filterInOtherArray(filteredQuotes, networkId, 'networkGroupId');
	}

	if (opConsultationCoPaymentId?.length) {
		filteredQuotes = filterInOtherArray(filteredQuotes, opConsultationCoPaymentId, 'coPaymentsOPConsultations');
	}

	if (diagnosticCoPaymentId?.length)
		filteredQuotes = filterInOtherArray(filteredQuotes, diagnosticCoPaymentId, 'coPaymentsDiagnostic');

	if (pharmacyCoPaymentId?.length)
		filteredQuotes = filterInOtherArray(filteredQuotes, pharmacyCoPaymentId, 'coPaymentsPharmacy');

	return filteredQuotes;
};
